import DesktopOnly from 'components/checkout/caap/DesktopOnly';
import SmallScreenOnly from 'components/checkout/caap/SmallScreenOnly';
import { Spinner } from 'components/Loader';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import css from 'styles/components/checkout/caap/sectionLoading.scss';

const SectionLoading = ({ heading, msg, step }) => (
  <div>
    <DesktopOnly>
      <Row>
        <RowSpan span="4">
          <div className={css.inactiveTitleBar}>
            <div className={css.titleWrapper}>
              <div className={css.stepIndex}>
                <h3>{step}</h3>
              </div>
              <h4 className={css.title}>{heading}</h4>
            </div>
          </div>
        </RowSpan>
        <RowSpan span="8">
          <Spinner color="#000" /> { msg }
        </RowSpan>
      </Row>
    </DesktopOnly>
    <SmallScreenOnly>
      <Row>
        <RowSpan span="12">
          <Spinner color="#000" /> {msg}
        </RowSpan>
      </Row>
    </SmallScreenOnly>
  </div>
);

export default SectionLoading;
